import { Grid, TextField } from '@mui/material';
import FormInputLabel from 'common/FormInputLabel';
import Subtext from 'common/Subtext';
import InputMask from 'react-input-mask';

import { useEffect, useState } from 'react';

export default function FormTextInputPhoneMask({
    formData,
    label,
    name,
    value = null,
    handleChange,
    placeholder,
    InputProps,
    type = 'text',
    subText = '',
    subtext,
    helperText = '',
    labelSize = 6,
    textSize = 6,
    required = false,
    isTextFeild = true,
    noLabel = false,
    additionAction = null,
    disabled = false,
}) {
    const [inputValue, setInputValue] = useState(value);
    const [isMasked, setIsMasked] = useState(value ? value.startsWith('+1') : true);

    useEffect(() => {
        setInputValue(value);
        setIsMasked(value ? value.startsWith('+1') : true);
    }, [value]);

    const handleInputChange = (e) => {
        let newValue = e.target.value;

        // If user modifies the value, apply the mask
        if (!isMasked && newValue.startsWith('+1')) {
            setIsMasked(true);
        }

        setInputValue(newValue);
        handleChange(e);
    };

    return (
        <>
            {!noLabel && <FormInputLabel label={label} subText={subText} labelSize={labelSize} required={required} />}
            {subtext && <Subtext>{subtext}</Subtext>}

            {isTextFeild && (
                <Grid
                    item
                    xs={textSize}
                    sx={{
                        marginBottom: '16px',
                    }}
                >
                    {isMasked ? (
                        <InputMask
                            mask="+1 (999) 999-9999"
                            value={inputValue}
                            disabled={disabled}
                            maskChar=" "
                            onChange={handleInputChange}
                        >
                            {() => (
                                <TextField
                                    fullWidth
                                    name={name}
                                    value={inputValue}
                                    required={required}
                                    placeholder={placeholder}
                                    type={type}
                                    InputProps={InputProps}
                                    disabled={disabled}
                                    sx={{
                                        '& .MuiOutlinedInput-input::placeholder': {
                                            color: '#4A4A4A',
                                            opacity: 1,
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '8px',
                                            transition: 'all 0.3s ease',
                                            backgroundColor: '#f5f1ed',
                                            border: '1px solid #cbc1b7',
                                            ...(disabled && {
                                                opacity: 0.6,
                                            }),
                                            '&:hover': {
                                                borderColor: '#ff5f39',
                                                backgroundColor: 'white',
                                            },
                                            '&.Mui-focused': {
                                                borderColor: '#ff5f39',
                                                backgroundColor: 'white',
                                                boxShadow: '0 0 0 2px rgba(255, 95, 57, 0.1)',
                                            },
                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: 'none',
                                        },
                                        '& .MuiInputBase-input': {
                                            color: '#000000',
                                        },
                                    }}
                                />
                            )}
                        </InputMask>
                    ) : (
                        <TextField
                            fullWidth
                            name={name}
                            value={inputValue}
                            required={required}
                            placeholder={placeholder}
                            type={type}
                            InputProps={InputProps}
                            disabled={disabled}
                            onChange={handleInputChange}
                            sx={{
                                '& .MuiOutlinedInput-input::placeholder': {
                                    color: '#4A4A4A',
                                    opacity: 1,
                                },
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                    transition: 'all 0.3s ease',
                                    backgroundColor: '#f5f1ed',
                                    border: '1px solid #cbc1b7',
                                    ...(disabled && {
                                        opacity: 0.6,
                                    }),
                                    '&:hover': {
                                        borderColor: '#ff5f39',
                                        backgroundColor: 'white',
                                    },
                                    '&.Mui-focused': {
                                        borderColor: '#ff5f39',
                                        backgroundColor: 'white',
                                        boxShadow: '0 0 0 2px rgba(255, 95, 57, 0.1)',
                                    },
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none',
                                },
                                '& .MuiInputBase-input': {
                                    color: '#000000',
                                },
                            }}
                        />
                    )}

                    {
                        <span className={'flex items-center justify-between'}>
                            {helperText && <span className={'help-text mt-1'}>{helperText}</span>}
                            {additionAction && additionAction}
                        </span>
                    }
                </Grid>
            )}
        </>
    );
}
